// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"b05f6b94","480":"b05f6b94","859":"b1b58376"}[chunkId] + ".chunk.css";
};